import React, { Component } from "react";
import { Spin, Card, Divider, Popover, Form } from "antd";
import QRCode from "qrcode.react";
import { app, config } from "../app";
import PropTypes from "prop-types";
import "braft-editor/dist/output.css";

const FormItem = Form.Item;
class NewsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  render() {
    let { loading, data, isDo } = this.props,
      formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      };
    return loading ? (
      <div style={{ textAlign: "center" }}>
        <Spin size="large" />
      </div>
    ) : (
      <div style={{ padding: "0 20px" }}>
        <div
          style={{
            maxWidth: 1190,
            margin: "0 auto",
            padding: "20px 0",
          }}
        >
          <Form>
            {isDo ? null : (
              <div
                style={{
                  padding: 10,
                  border: "1px gray dashed",
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                }}
              >
                {data.audit_status == 0 ? (
                  <p> 审核状态： {data.audit_name}</p>
                ) : (
                  <div>
                    <p>审核人： {data.audit_admin}</p>
                    <p>审核状态： {data.audit_name}</p>
                    <p>审核时间： {data.audit_time}</p>
                    {data.detail && (
                      <p style={{ display: "flex" }}>
                        <span style={{ width: "75px" }}>审核原因：</span>{" "}
                        <span
                          style={{ color: "red", flexWrap: "wrap", flex: 1 }}
                        >
                          {data.detail}
                        </span>
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}
            <FormItem
              label="任务方式"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>
                {data.ally_way == 1
                  ? "单队任务"
                  : data.ally_way == 2
                  ? "联合任务"
                  : ""}
              </span>
            </FormItem>
            {data.ally_way == 2 ? (
              <FormItem
                label="任务等级"
                {...formItemLayout}
                style={{ margin: " 0 0 10px" }}
              >
                <p>{data.ally_grade}</p>
                <p>
                  {data.ally_rights_name
                    .map((item) => item.level_name)
                    .join(",")}
                </p>
              </FormItem>
            ) : null}

            <FormItem
              label="出队队伍"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              {data.team_info.map((item) => item.teamname).join(" , ")}
            </FormItem>
            <FormItem
              label="是否保密"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.secret==1?'是':data.secret==0?'否':''}</span>
            </FormItem>
            <FormItem
              label="任务类型"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.class_name}</span>
            </FormItem>
            <FormItem
              label="任务名称"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.title}</span>
            </FormItem>
            <FormItem
              label="任务开始时间"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.task_strat_time}</span>
            </FormItem>
            <FormItem
              label="任务结束时间"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.task_end_time}</span>
            </FormItem>
            <FormItem
              label="任务地址"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.task_address}</span>
            </FormItem>
            <FormItem
              label="需求人数"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.need_number} 人</span>
            </FormItem>
            <FormItem
              label="服务时长/人"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.task_duration} 小时</span>
            </FormItem>
            <FormItem
              label="任务积分/人"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.task_integral} 分</span>
            </FormItem>
            <FormItem
              label="报名要求"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.apply_ask}</span>
            </FormItem>
            <FormItem
              label="任务简介"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.task_remark}</span>
            </FormItem>
            <FormItem
              label="报名方式"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span>{data.method == 1 ? "系统分配" : "队员主动报名"}</span>
            </FormItem>
            <FormItem
              label="任务身份"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              {data.apply_type.indexOf(",") !== -1
                ? data.apply_type
                    .split(",")
                    .map((item) => {
                      switch (item) {
                        case "1":
                          return "义警";
                        case "2":
                          return "见习义警";
                        case "3":
                          return "平安志愿者";
                        default:
                          return "";
                      }
                    })
                    .join(" , ")
                : data.apply_type === "1"
                ? "义警"
                : data.apply_type === "2"
                ? "见习义警"
                : data.apply_type === "3"
                ? "平安志愿者"
                : ""}
            </FormItem>
            {data.method == 1 && (
              <FormItem
                label="任务队员"
                {...formItemLayout}
                style={{ margin: " 0 0 10px" }}
              >
                {data.user_info.map((item) => item.vname).join(" , ")}
              </FormItem>
            )}
          </Form>
        </div>
      </div>
    );
  }
}

NewsDetail.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.any,
};

export default NewsDetail;



// WEBPACK FOOTER //
// ./src/components/taskDetail2.jsx